<template>
  <div class="listTable">
    <el-table
      :data="tableData"
      border
      :header-cell-style="{ 'text-align': 'center','background-color':'#F0F7FF' }"
      style="width: 100%"
      v-loading="loading"
      :show-summary="tableParams['isSummaryMethod']?true:false"
      :summary-method="getSummaries"
    >
      <el-table-column
        v-if="tableParams['index']"
        :label="tableParams['indexLabel']"
        type="index"
        width="50"
        :align="tableParams['align']"
      >
      </el-table-column>

      <el-table-column
        v-for="(item) in tableParams.column"
        :key="item.prop"
        :prop="item.prop"
        :label="item.label"
        :width="item.width"
        v-if="item.display!==false"
      >
        <template slot="header" v-if="item.headerRequired">
          <span style="color: red"> *</span> {{ item.label }}
        </template>
        <template slot="header" v-if="item.labelSlot">
          <slot :name="item.prop+'Label'"> </slot>
        </template>


        <template slot-scope="scope">
          <template v-if="item.tableSlot">
            <slot :name="item.prop" :index="scope.$index"> </slot>
          </template>

          <template v-else-if="item.type == 'select'">
            <CommonSelect
               ref="selectInputRef"
               :isTableCustom="true"
              :placeholder="
                item['placeholder'] != undefined
                  ? item['placeholder']
                  : '请选择'
              "
              :disabled="item['disabled']"
              :searchKey="item['searchKey'] ? item['searchKey'] : item['prop']"
              selectStyle="true"
              :bindLabel="item['bindLabel']"
              :bindKey="item['bindKey']"
              :bindValue="item['bindLabel']"
              :methods="item['methods']"
              :dataMethod="item['dataMethod']"
              :dataUrl="item['dataUrl']"
              :bindId="
                scope.row[item['bindId']] ? scope.row[item['bindId']] : ''
              "

              @handleChange="
                (el) => setId(el, scope.$index, item['bindId'], item['bindKey'])
              "
            />
          </template>
          <template v-else-if="item.type == 'selectList'">
            <el-select
              v-model="scope.row[item.prop]"
              @change="(el) => handleSelectList(el, scope.$index, item)"
              :disabled="item['disabled']"
              :placeholder="
                item['placeholder'] != undefined
                  ? item['placeholder']
                  : '请选择'
              "
            >
              <el-option
                v-for="el in item['list']"
                :key="el[item.bindKey]"
                :label="el[item.bindLabel]"
                :value="el[item.bindKey]"
              >
              </el-option>
            </el-select>
          </template>

          <template v-else-if="item.type == 'input'">
            <el-input
              size="small"
              v-model="scope.row[item.prop]"
              :disabled="item['disabled']"
              :placeholder="
                item['placeholder'] != undefined
                  ? item['placeholder']
                  : '请输入'
              "
              :type="item['inputType'] ? item['inputType'] : 'text'"
            >
              <template slot="append" v-if="item.append">{{
                item.append
              }}</template>
            </el-input>
          </template>
          <template v-else-if="item.type == 'inputNumber'">
            <el-input-number
              size="small"
              controls-position="right"
              :disabled="item['disabled']"
              v-model="scope.row[item.prop]"
              :placeholder="
                item['placeholder'] != undefined
                  ? item['placeholder']
                  : '请输入'
              "          
              :max="item['max'] ? item['max'] : 'Infinity'"
            >
            </el-input-number>
          </template>
          <template v-else-if="item.type == 'date'">
            <div class="form_slot">
              <el-date-picker
                size="small"
                v-model="scope.row[item.prop]"
                :disabled="item['disabled']"
                :type="item['dateType'] ? item['dateType'] : 'date'"
                :format="item['format'] ? item['format'] : 'yyyy-MM-dd'"
                :valueFormat="
                  item['valueFormat'] ? item['valueFormat'] : 'yyyy-MM-dd'
                "
                :placeholder="
                  item['placeholder'] != undefined
                    ? item['placeholder']
                    : '请选择'
                "
              />
            </div>
          </template>
          <template v-else-if="item.type == 'amountRate'">
            <div class="form_slot">
              <el-input
                size="small"
                v-model="scope.row[item.prop]"
                :disabled="item['disabled']"
                :placeholder="
                  item['placeholder'] != undefined
                    ? item['placeholder']
                    : '请输入'
                "
                @change="
                  changeInput(
                    item['propTwo'],
                    item['prop'],
                    'ratio',
                    scope.$index
                  )
                "
              >
                <template slot="append" v-if="item.append">{{
                  item.append
                }}</template>
              </el-input>

              <el-input
                v-model="scope.row[item.propTwo]"
                :disabled="item['disabled']"
                :placeholder="
                  item['placeholderTwo'] != undefined
                    ? item['placeholderTwo']
                    : '请输入'
                "
                size="small"
                @change="
                  changeInput(
                    item['prop'],
                    item['propTwo'],
                    'number',
                    scope.$index
                  )
                "
              >
                <template slot="append" v-if="item.appendRate">{{
                  item.appendRate
                }}</template>
              </el-input>
            </div>
          </template>
          <template v-else>
            <div class="align_text">
              {{
                item.formatter
                  ? item.formatter(item.label, scope.row[item.prop])
                  : scope.row[item.prop]
              }}
            </div>
          </template>
        </template>
      </el-table-column>

      <!-- 操作功能 -->
      <el-table-column
        label="操作"
        v-if="!tableParams['readonly'] && !readOnly"
        align="center"
        :width="tableParams['menuWidth']"
      >
        <template slot-scope="scope">
          <div class="flex_wrapper" v-if="tableParams['isButton']">
            
            <el-button
              type="primary"
              plain
              size="small"
              icon="el-icon-plus"
              @click="add(scope.$index)"
              v-if="tableParams['detailAddBtn']"
              >新增
            </el-button>
            <el-button
              type="primary"
              plain
              size="small"
              icon="el-icon-edit"
              @click="handleEdit(scope.$index, scope.row)"
              v-if="tableParams['editBtn']"
              >编辑
            </el-button>

            <el-button
              type="danger"
              @click="del(scope.$index)"
              v-if="tableParams['delBtn']"
              plain
              size="small"
              icon="el-icon-delete-solid"
              >删除
            </el-button>
            <el-button
              type="success"
              plain
              size="small"
              icon="el-icon-arrow-right"
              @click="handleDetail(scope.$index, scope.row)"
              v-if="tableParams['detailBtn']"
              >详情
            </el-button>

      
          </div>
          <div class="flex_wrapper" v-else>
            
            <div
              class="brand_color icon_type"
              @click="add(scope.$index)"
              v-if="tableParams['detailAddBtn']"
            >
              <i class="el-icon-plus" v-if="tableParams['menuIcon']"></i>
              新增
            </div>
            <div
              class="brand_color icon_type"
              @click="handleEdit(scope.$index, scope.row)"
              v-if="tableParams['editBtn']"
            >
              <i class="el-icon-edit" v-if="tableParams['menuIcon']"></i>
              编辑
            </div>

            <div
              class="del_color icon_type"
              @click="del(scope.$index)"
              v-if="tableParams['delBtn']"
            >
              <i
                class="el-icon-delete-solid"
                v-if="tableParams['menuIcon']"
              ></i>
              删除
            </div>
            <div
              class="success_color icon_type"
              @click="handleDetail(scope.$index, scope.row)"
              v-if="tableParams['detailBtn']"
            >
              <i class="el-icon-video-play" v-if="tableParams['menuIcon']"></i>
              详情
            </div>

            
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="table_custom_add" v-if="tableParams['addBtn'] && !readOnly">
      <el-button icon="el-icon-circle-plus-outline" @click="add"
        >添加</el-button
      >
    </div>
  </div>
  <!-- 
    *     <TableCustom
                :tableData="tableInfoConfig['tableData']"  //数据列表
                :tableParams="tableInfoConfig['tableParams']"  //操作参数
                
              />
    *     tableInfoConfig: {
        tableData: [
          {
            x: 1,
            y: 2,
            z: 3,
          },
        ],
        tableParams: {
          menuWidth: 200,
          detailBtn: true,
          editBtn: true,
          delBtn: true,
          index: true,
          indexLabel: "序号",
          align:'center',
          readonly:false,
          column: [
          
          {
            label: "费用类型",
            prop: "indexNumber",
            type: "select",
            typeInfo: {
              bindLabel: "dictValue",
              bindKey: "dictKey",
              methods: "get",
              dataMethod: "params",
              dataUrl:
                "/blade-system/dict-biz/dictionary?code=dict_outlay_type",
              bindId: "dictOutlayType",
            },
          },
          {
            label: "金额",
            prop: "xxxxx",
            type: "input",
            typeInfo: {
              placeholder: "请输入金额",
              append: "元",
              inputType: "number",
            },
          },
          {
            label: "金额",
            prop: "yyy",
            type: "inputNumber",
            typeInfo: {
              placeholder: "请输入金额",
              
              max: "10",
            },
          },
          {
            label: "日期",
            prop: "date",
            type: "date",
            typeInfo: {
              placeholder: "请选择时间",
              format:"yyyy-MM-dd",
              valueFormat:"yyyy-MM-dd"
            },
          },
          {
            label: "金额&比例",
            prop: "outlayRate",
            propTwo: "outlayAmount",
            type: "amountRate",
            typeInfo: {
              placeholder: "请输入金额",
              append: "元",
              appendRate:'%',
              max: "10",
            },
          },
        ],
      }
    *     
    *     
    *
    *
    *
    *
    *
    *
    *
   -->
</template>

<script>
import Vue from "vue";
import { floatAdd,deepCopy } from "@/util/util";
import CommonSelect from "@/components/commonSelect/commonSelect";
export default {
  name: "accessory",
  data() {
    return {
      addObj: {},
      loading: false,
    };
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tableParams: {
      type: Object,
      default: () => {},
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    sumProperty: Array,
      default: () => [],
  },
  watch: {
    tableData: {
      handler: function (val) {
        this.loading = false;
      },
      deep: true,
    },
  },
  computed: {},
  components: {
    CommonSelect,
  },
  created() {},
  mounted() {
    let addObj = {};
    this.tableParams.column.map((item) => {
      addObj[item.prop] = undefined;
    });
    this.addObj = addObj;
  },
  methods: {
    changeInput(toName, name, type, index) {
      let tableData =this.tableData;
      if (this.quotationPrice) {
        if (type == "ratio") {
          tableData[index][toName] = (
            (Number(this.quotationPrice) * Number(tableData[index][name])) /
            100
          ).toFixed(2);
        } else {
          tableData[index][toName] = (
            (Number(tableData[index][name]) / Number(this.quotationPrice)) *
            100
          ).toFixed(2);
        }
        this.tableData = tableData;
      }
    },

    del(index) {
      let that = this;
      if (this.tableParams["detailAddBtn"] && this.tableData.length == 1) {
        this.$message.error("至少保留一条数据!");
        return;
      }
      this.$confirm("是否删除此条数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        that.loading = true;
        that.tableData.splice(index, 1);
        that.$emit("handleDel", index);
      });
    },
    add() {
      let addObj = Object.assign({},this.addObj);
      this.tableData.push(addObj);

      this.$emit("handleAdd", this.tableData);
    },
    setId(item, index, name, key) {
      if (item) {
         this.tableData[index][name] = item[key];
      }

    },
    handleSelectList(el, index, item) {
      this.$emit("handleSelectList", el, index, item);
    },
    handleDetail(index, row) {
      this.$emit("handleDetail", index, row);
    },
    handleEdit(index, row) {
      this.$emit("handleEdit", index, row);
    },
    getSummaries(param) {
      const sumProperty = this.sumProperty;
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (sumProperty.includes(column.property)) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(Number(value)))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return floatAdd(prev , curr);
              } else {
                return prev;
              }
            }, 0);
            sums[index] = `${this.getMoney(sums[index])}`;
          } else {
            sums[index] = "";
          }
        } else {
          sums[index] = "";
          return;
        }
      });

      return sums;
    },
  },
};
</script>

<style lang="scss" scoped>
.listTable {
  background-color: #fff;
  margin-top: 20px;
  width: 100%;
}
.table_custom_add {
  padding: 20px 0;
  text-align: center;
}
.el-table {
  border: 1px solid #e2e2e2;
  border-right: none;
  border-bottom: none;
  th {
    background: #f2f2f2;
    color: #333;
  }
}
.action_block {
  display: flex;
  flex-direction: row;
  a {
    cursor: pointer;
    margin: 0 8px;
  }
}
.success_color {
  color: #67c23a;
}
.brand_color {
  color: #409eff;
}
.del_color {
  color: #f56c6c;
}

/deep/ .table_custom_add {
  .el-button {
    width: 300px;
    height: 40px;
  }
}
/deep/ .el-input-number {
  width: 100% !important;
}
/deep/ .el-date-editor.el-input {
  width:  100% !important;
}
.flex_wrapper {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
.form_slot {
  display: flex;
  align-items: center;
}
/deep/ .el-input-group__append {
  padding: 0 5px;
}
.icon_type {
  cursor: pointer;
}
/deep/ .el-table--border th {
  font-weight: 400 !important;
}
.align_text {
  text-align: center;
}
/deep/ .el-table .cell {
  text-align: center;
  
}
/deep/ .el-table {
  display: flex;
  flex-direction: column;
}
/deep/.el-table__body-wrapper {
    order: 1 !important;
  }

  /deep/.el-table__fixed-footer-wrapper{
    top: 40px !important;
    z-index: 0;
  }
  /deep/.avue_no_index {
    .el-table__fixed-body-wrapper{
       top: 80px !important
    }
  }
  /deep/.el-table__footer-wrapper,/deep/.el-table__fixed-footer-wrapper {
   .cell {
      color:red
    }
    td {
        background-color: #F0F7FF;
    }
 }
 /deep/ .el-input__inner {
   padding:0 0 0 4px;
 }
 /deep/  .el-input-number__decrease {
    display: none;
 }
 /deep/  .el-input-number__increase {
  display: none;
}
/deep/  .el-input-number.is-controls-right .el-input__inner {
    padding-left:4px;
    padding-right: 0px;
    text-align: left;


}
/deep/ .el-table{
  border: 1px solid #e0eeff;
}
/deep/ .el-input__prefix .el-input__icon {
  display: none;
}
/deep/ .el-input__icon {
  display: flex;
  align-items: center;
}

/deep/ .el-input__inner {
   height: 32px;
}
</style>

